import { render, staticRenderFns } from "./interact-shaded.vue?vue&type=template&id=2a96450b&"
import script from "./interact-shaded.vue?vue&type=script&lang=js&"
export * from "./interact-shaded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports